<template>
  <v-layout
      row
      :style="maxWidth"
  >
    <v-flex
        class="ml-3 pl-sm-1"
        :style="maxWidth"
    >
      <breadcrumbs
          :items="breadcrumbsItems"
      ></breadcrumbs>
      <v-card class="ma-1" outlined :style="maxHeight">
        <v-row class="ma-1">
          <v-card-title>
            {{ group.name }}'s Outlets
          </v-card-title>
        </v-row>
        <v-text-field
            v-model="searchOutlets"
            append-icon="mdi-magnify"
            label="Search"
            hide-details
            class="ma-1 col-6 pl-2 pb-4"
            outlined
            autocomplete="off"
            dense
        ></v-text-field>
        <v-data-table
            :headers="outletsHeaders"
            :items="outlets"
            :search="searchOutlets"
            class="display-3 font-weight-medium"
            dense
        >
          <template
              v-slot:item.actions="{ item }"
          >
            <v-icon
                class="mr-8"
                color="primary"
                @click="queues(item)"
            >
              mdi-eye
            </v-icon>
            <v-icon
                @click="editOutlet(item)"
            >
              mdi-pencil
            </v-icon>
          </template>
        </v-data-table>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  name: 'group',
  props: ['group', 'outlets'],
  data: () => {
    return {
      outletsData: [],
      searchOutlets: null,
      outletsHeaders: [
        {
          text: 'Outlet Name',
          align: 'start',
          value: 'name',
        },
        {
          text: 'Description',
          value: 'description',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false
        }
      ],
      breadcrumbsItems: '',
    }
  },
  computed: {
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    },
    maxHeight() {
      return {
        maxHeight: window.innerHeight + 'px'
      }
    }
  },
  methods: {
    editOutlet(o) {
      window.location.href = '/outlet/' + o.id + '/edit'
    },
    deleteOutlet(o) {
      const i = this.outlets.indexOf(o);
      if (confirm('Are you sure you want to delete this outlet?')) {
        axios.delete('/outlet/' + o.id).then(response => {
          this.outlets.splice(i, 1);
        });
      }
    },
    createOutlet() {
      window.location.href = '/outlet/create'
    },
    queues(o) {
      window.location.href = '/outlet/' + o.id
    }
  },
  beforeMount() {
    this.outletsData = this.outlets;
    this.breadcrumbsItems = [
      {
        disabled: true,
        href: '#',
        link: true,
        text: 'Home',
      },
    ];
  }
}
</script>

<style>
.v-data-table-header th {
  white-space: nowrap;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Groups/Group.vue